// components/ForgotPassword.js
import React, { useState } from "react";
import { auth } from "./firebase";
import { sendPasswordResetEmail } from "firebase/auth";
import "../styles/login.css"; // same CSS as Login

function ForgotPassword({ onBack }) {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const firebaseErrorMessages = {
    "auth/invalid-email": "Please enter a valid email address.",
    "auth/user-not-found": "No account found with this email.",
    "auth/too-many-requests": "Too many requests. Try again later.",
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      await sendPasswordResetEmail(auth, email);
      alert("Password reset email sent!");
    } catch (err) {
      const message =
        firebaseErrorMessages[err.code] || "Something went wrong. Please try again.";
      setError(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={`login-container ${loading ? "loading-overlay" : ""}`}>
      {loading && (
        <div className="spinner-overlay">
          <div className="spinner"></div>
        </div>
      )}

      <form onSubmit={handleSubmit} className="login-form">
        <div className="login-logo">
          <img
            className="login-image"
            src={require("../images/logo.png")}
            alt="CIET Logo"
          />
        </div>
        <h1 className="login-title" style={{ fontSize: "1.6rem", color: "var(--color-primary)", marginBottom: "0" }}>
          Learner Portal
        </h1>
        <h1 className="login-title">Reset Your Password</h1>

        {error && <div className="error-box">{error}</div>}

        <div className="form-group">
          <input
            type="email"
            placeholder="Email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="form-input"
            required
            disabled={loading}
          />
        </div>

        <button type="submit" className="btn btn-primary" disabled={loading}>
          Send Reset Email
        </button>

        <div className="login-options">
          <p onClick={onBack} className="link">
            Back to Login
          </p>
        </div>
      </form>
    </div>
  );
}

export default ForgotPassword;
